import { useState, useEffect } from "react";
import "./AttendancePage.css";
import Navbar8 from "./navbar8";
import Footer4 from "./footer4";
import { Link, useNavigate } from "react-router-dom";
import { Fragment } from "react";
import { Bar } from "react-chartjs-2";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "chart.js/auto";

const AttendancePage = () => {
  const userRole = sessionStorage.getItem("userRole");
  const navigate = useNavigate();
  const [dailyWage] = useState(500);

  const [attendance, setAttendance] = useState(() => {
    const savedData = sessionStorage.getItem("attendanceRecords");
    return savedData ? JSON.parse(savedData) : [];
  });

  const [laborers, setLaborers] = useState(() => {
    const savedData = sessionStorage.getItem("laborers");
    return savedData
      ? JSON.parse(savedData)
      : [
          { id: 1, name: "Rahul Kumar", attendance: [] },
          { id: 2, name: "Amit Sharma", attendance: [] },
          { id: 3, name: "Deepak Gupta", attendance: [] },
        ];
  });

  useEffect(() => {
    sessionStorage.setItem("attendanceRecords", JSON.stringify(attendance));
    sessionStorage.setItem("laborers", JSON.stringify(laborers));
  }, [attendance, laborers]);

  const getCurrentTime = () => {
    const now = new Date();
    let hours = now.getHours();
    let minutes = now.getMinutes();
    let ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    return `${hours}:${minutes} ${ampm}`;
  };

  const markAttendance = () => {
    const today = new Date().toISOString().split("T")[0];

    if (!attendance.find((record) => record.date === today)) {
      setAttendance((prev) => {
        const updatedAttendance = [
          { date: today, time: getCurrentTime() },
          ...prev,
        ];
        sessionStorage.setItem(
          "attendanceRecords",
          JSON.stringify(updatedAttendance)
        );
        return updatedAttendance;
      });
    }
  };

  const markAttendanceForLaborer = (id) => {
    const today = new Date().toISOString().split("T")[0];

    setLaborers((prev) =>
      prev.map((lab) =>
        lab.id === id && !lab.attendance.some((att) => att.date === today)
          ? {
              ...lab,
              attendance: [
                ...lab.attendance,
                { date: today, time: getCurrentTime() },
              ],
            }
          : lab
      )
    );
  };

  const resetAttendance = () => {
    setAttendance([]);
    sessionStorage.setItem("attendanceRecords", JSON.stringify([]));
  };

  const resetLaborerAttendance = (id) => {
    setLaborers((prev) =>
      prev.map((lab) => (lab.id === id ? { ...lab, attendance: [] } : lab))
    );
    sessionStorage.setItem("laborers", JSON.stringify(laborers));
  };

  // Generate data for the chart
  const attendanceDates = attendance.map((record) => record.date);
  const chartData = {
    labels: attendanceDates.reverse().slice(0, 7),
    datasets: [
      {
        label: "Attendance Frequency (Last 7 Days)",
        data: new Array(attendanceDates.length).fill(1),
        backgroundColor: "#007bff",
        borderColor: "#0056b3",
        borderWidth: 1,
      },
    ],
  };

  return (
    <>
      <Navbar8
        link1={<Link to="/home">Home</Link>}
        link2={
          <Fragment>
            <span>About Us</span>
          </Fragment>
        }
        link3={
          <Fragment>
            <span>Contact</span>
          </Fragment>
        }
        link4={
          <Fragment>
            <span>More</span>
          </Fragment>
        }
        action1={
          <Fragment>
            <span>Profile</span>
          </Fragment>
        }
        action2={
          <Link to="/login" className="nav-link">
            <span>Log Out</span>
          </Link>
        }
      />

      <div className="attendance-container">
        <h1 className="attendance-title">
          {userRole === "Labour" ? "My Attendance" : "Manage Attendance"}
        </h1>

        {userRole === "Labour" ? (
          <>
            <div className="summary-card">
              <h2>Total Days Present: {attendance.length}</h2>
              <h3>Total Salary: ₹{attendance.length * dailyWage}</h3>
            </div>

            <div className="attendance-box">
              <button className="attendance-btn-labour" onClick={markAttendance}>
                Mark Present
              </button>
              <button
                className="wages-btn"
                onClick={() => navigate("/wages")}
              >
                View Wages
              </button>
            </div>

            <div className="chart-container">
              <Bar data={chartData} />
            </div>

            <div className="calendar-container">
              <Calendar
                tileClassName={({ date }) =>
                  attendance.some(
                    (record) => record.date === date.toISOString().split("T")[0]
                  )
                    ? "highlight"
                    : ""
                }
              />
            </div>

            <button className="reset-btn" onClick={resetAttendance}>
              Reset Attendance
            </button>

            <div className="attendance-table">
              <h2>Attendance History</h2>
              <table>
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Time</th>
                  </tr>
                </thead>
                <tbody>
                  {attendance.length === 0 ? (
                    <tr>
                      <td colSpan="2">No records found.</td>
                    </tr>
                  ) : (
                    attendance.map((record, index) => (
                      <tr key={index}>
                        <td>{record.date}</td>
                        <td>{record.time}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </>
        ) : (
          <div className="attendance-list">
            <h2 className="list-title">Laborers List</h2>
            {laborers.length === 0 ? (
              <p>No laborers available.</p>
            ) : (
              laborers.map((lab) => (
                <>
                <div key={lab.id} className="attendance-item">
                  <span className="laborer-name">{lab.name}</span>
                  <button
                    className="attendance-btn"
                    onClick={() => markAttendanceForLaborer(lab.id)}
                  >
                    Mark Present
                  </button>
                  <button
                    className="reset-btn"
                    onClick={() => resetLaborerAttendance(lab.id)}
                  >
                    Reset Attendance
                  </button>
                  <button
                    className="wages-btn"
                    onClick={() => navigate("/wages-admin")}
                  >
                    Wages
                  </button>
                </div>
                <div className="attendance-table">
                    <table>
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Time</th>
                        </tr>
                      </thead>
                      <tbody>
                        {lab.attendance.length === 0 ? (
                          <tr>
                            <td colSpan="2">No attendance recorded.</td>
                          </tr>
                        ) : (
                          lab.attendance.map((record, index) => (
                            <tr key={index}>
                              <td>{record.date}</td>
                              <td>{record.time}</td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </>
              ))
            )}
          </div>
        )}
      </div>

      <Footer4
        link1={<Link to="/home">Home</Link>}
        link2={
          <Fragment>
            <span>About Us</span>
          </Fragment>
        }
        link3={
          <Fragment>
            <span>Contact Us</span>
          </Fragment>
        }
        link4={
          <Fragment>
            <span>FAQ</span>
          </Fragment>
        }
        termsLink={
          <Fragment>
            <span>Terms and Conditions</span>
          </Fragment>
        }
        cookiesLink={
          <Fragment>
            <span>Cookies Policy</span>
          </Fragment>
        }
        privacyLink={
          <Fragment>
            <span>Privacy Policy</span>
          </Fragment>
        }
      />
    </>
  );
};

export default AttendancePage;
